import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'toggle': 'toggle', } };
    }

    toggle( e ){
        if( e.currentTarget.classList.contains( 'active' ) ) return;
        this.$( 'toggle' ).forEach( (tab, index ) => {
           tab.classList.toggle( 'active', tab === e.currentTarget );
           this.$( 'panel' )[ index ].classList.toggle( 'active', tab === e.currentTarget );
        });
        this.call( 'update', false, 'Scroll' );
    }

}
